
<div style="position: relative">
    <div class="v-flex" style="position: absolute; right: 4px; top: 6px; z-index: 10">
        <div class="error--text">({{ errors }} Fehler)</div>
        <div class="warning--text ml-2">({{ warnings }} Warnungen)</div>
    </div>
    <v-tabs
        v-model      = "tabs"
        class        = "mt-3 folder-tabs ml-0 mr-0 pr-0"
        active-class = "folder-tab-active primary"
        height       = "32"
        light
    >
        <v-tab
            class = "folder-tab"
            :key  = "1"
        >
            Eingabedatei
        </v-tab>
    </v-tabs>

    <v-tabs-items
        v-model = "tabs"
        class   = "w-100"
        style   = "height: calc(100% - 40px); margin-top: -2px!important;"
    >
        <v-tab-item
            :key  = "1"
            style = " height: calc(100% + 20px)"
        >
            <p-import-content
                id             = "import-in-id"
                :rows          = "displayRows"
                :columns       = "columns"
                :size          = "size"
                :show-units    = "false"
                :filter        = "filter"
                :scroll-width  = "scrollWidth"
                :right-padding = "70"
                :target-format = "false"
            />
        </v-tab-item>
    </v-tabs-items>
</div>
